import { type JSX } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { buildSignInPath } from '@/lib/sign-in-redirect';
import { Navigate, useLocation } from 'react-router-dom';

type AuthGuardProps = {
    children: JSX.Element;
};

export function AuthGuard({ children }: AuthGuardProps): JSX.Element | null {
    const { isLoading, isAuthenticated, isLoggingOut } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return null;
    }

    if (!isLoading && !isAuthenticated && !isLoggingOut) {
        return <Navigate to={buildSignInPath(location)} replace />;
    }

    return children;
}
